import { useEffect, useRef } from 'react';
import { wsIp } from '@/lib/axios';

export default function useWebSocket(onMessage) {
  const wsRef = useRef(null);

  useEffect(() => {
    const token = localStorage.getItem('authToken');
    if (!token) return;

    const ws = new WebSocket(`${wsIp}/ws/chat?token=${token}`);
    wsRef.current = ws;

    ws.onopen = () => {
      console.log('✅ WebSocket connected');
    };

    ws.onmessage = (event) => {
      if (typeof onMessage === 'function') {
        onMessage(event.data); // ✅ Triggers message update
      }
    };

    ws.onerror = (err) => {
      console.error('🛑 WebSocket error:', err);
    };

    ws.onclose = () => {
      console.log('❌ WebSocket closed');
    };

    return () => {
      if (ws.readyState === WebSocket.OPEN || ws.readyState === WebSocket.CONNECTING) {
        ws.close();
      }
    };
  }, [onMessage]);

  return wsRef;
}
